import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AddEmailForm } from '@/components/admin/AddEmailForm';

interface AddNewUserSectionProps {
  onSuccess: () => Promise<void>;
}

const AddNewUserSection: React.FC<AddNewUserSectionProps> = ({
  onSuccess
}) => {
  return (
    <Card className="border-none shadow-none bg-transparent">
      <CardContent className="px-0">
        <AddEmailForm onSuccess={onSuccess} />
      </CardContent>
    </Card>
  );
};

export default AddNewUserSection;
